import $ from 'jquery';

$(document).ready(() => {
	$('.js-load-more').bind('click', function (event) {
		event.preventDefault();
		$.ajax($(this).attr('href')).done(function(data){
			const $response = $(data);
			const html = $response.find('.js-load-more-container').html();
			$(html).appendTo('.js-load-more-container');
			if($response.find('.js-load-more').length) {
				$('.js-load-more').attr('href', $response.find('.js-load-more').attr('href'));
			} else {
				$('.js-load-more').hide();
			}
		});
	});
});
